module.exports = __webpack_public_path__ + "i18n/nl.7a463b702ff24e93a9dbc1193266ba5b.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/nl.json
// module id = 1543
// module chunks = 60